@import '../general';
@import 'footer';

:host {
  display: block;
}
